module.exports = __webpack_public_path__ + "static/img/xxzy.a548470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/xxzy.png
// module id = qGH/
// module chunks = 0